import React from "react";

const PageHero = ({ title, subtitle, eyebrow }) => (
  <section className="py-24 px-6" style={{ background: "transparent" }}>
    <div className="max-w-3xl mx-auto text-center">
      {eyebrow && (
        <span
          className="inline-block px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider mb-4"
          style={{
            background: "linear-gradient(135deg, rgba(75,111,212,0.12), rgba(255,122,122,0.09))",
            border: "1px solid rgba(75,111,212,0.2)",
            color: "var(--brand-cyan)",
          }}
        >
          {eyebrow}
        </span>
      )}
      <h1
        className="font-bold tracking-tight leading-[1.1]"
        style={{ fontSize: "clamp(2rem, 5vw, 3.5rem)" }}
      >
        {title}
      </h1>
      {subtitle && (
        <p
          className="mt-5 text-[16px] leading-relaxed max-w-2xl mx-auto"
          style={{ color: "var(--fg)", opacity: 0.85 }}
        >
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageHero;
